import posthogService from './lib/services/posthogService'
import sentryService from './lib/services/sentryService'
import yupService from './lib/services/yupService'

yupService.init()
posthogService.init()
sentryService.init()
